import React, { useEffect, useState } from 'react';
import './App.css';
import SocketService from 'services/SocketService';
import { setupOnRoomJoined } from 'services/socketEventsSetup';
import SocketProvider from 'components/Provider/SocketProvider';
import RoomProvider from 'components/Provider/RoomProvider';
import DimensionsProvider from 'components/Provider/DimensionsProvider';
import Navigation from 'components/Navigation/Navigation';
import PopupError from 'components/PopupError/PopupError';
import { createMuiTheme, ThemeProvider } from '@material-ui/core';

export const popupErrorRef = React.createRef();

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#FACE70',
    },
    secondary: {
      main: '#34bdeb',
    },
  },
});

function App() {
  const [socket, setSocket] = useState(null);
  const [room, setRoom] = useState(null);
  const [dimensions, setDimension] = useState(null)

  useEffect(() => {

    //Dimension
    function handleResize() {
      setDimension({
        w: window.innerWidth,
        h: window.innerHeight
      });
    }
    window.addEventListener('resize', handleResize);
    handleResize();

    // Socket
    if (!socket) {
      setSocket(new SocketService());
    }
    else {
      //socket.on('connect', () => console.log('connected'));
      setupOnRoomJoined(socket, setRoom);
    }

    return function cleanup() {
      window.removeEventListener('resize', handleResize);

      if (socket) {
        socket.disconnect();
      }
    }
  }, [socket]);

  return (
    <SocketProvider.Provider value={socket}>
      <RoomProvider.Provider value={{ room, setRoom }}>
        <DimensionsProvider.Provider value={dimensions}>
          <ThemeProvider theme={theme}>
            <div className="App">
              <Navigation />
              <PopupError ref={popupErrorRef} />
            </div>
          </ThemeProvider>
        </DimensionsProvider.Provider>
      </RoomProvider.Provider>
    </SocketProvider.Provider>
  );
}

export default App;
